import axios from 'axios';

import { authHeader } from '../../helpers/authHeader';
import { gboexResponse, gboexResponseError } from '../../helpers/response';

const baseAxiosAuthGateway = axios.create({
    baseURL: process.env.REACT_APP_GATEWAY
});

baseAxiosAuthGateway.interceptors.request.use(
    async (config) => {
        const auth = authHeader();
        config.headers.Authorization = auth.Authorization;
        config.headers['X-Client'] = 'portal-servicos';
        return config;
    });

baseAxiosAuthGateway.interceptors.response.use(
    async (response) => gboexResponse(response),
    async (error) => gboexResponseError(error)
);

export default baseAxiosAuthGateway;